const mEditionAcademyUsersProfileAssets = {
  mEditionAcademyUsersProfileAssets: {
    actions: {
      add: 'Incluir',
      remove: 'Quitar'
    },

    alerts: {
      createInscripcion: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo.',
        success: 'La inscripción fue procesada exitosamente. El alumno recibirá un email de notificación.'
      }
    }
  }
}
export default mEditionAcademyUsersProfileAssets
